
// TaskCategory.js - Expandable Task Lists
import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid';

const TaskCategory = ({ title, tasks, collapsible = false }) => {
    const [expanded, setExpanded] = useState(!collapsible);

    return (
        <div className="mb-4 bg-white rounded shadow-sm border">
            <button
                className="w-full flex items-center justify-between px-4 py-2"
                onClick={() => collapsible && setExpanded(!expanded)}
            >
                <h3 className="text-indigo-700 font-semibold">{title}</h3>
                {collapsible && (
                    expanded ? <ChevronUpIcon className="h-5 w-5" /> : <ChevronDownIcon className="h-5 w-5" />
                )}
            </button>
            {expanded && (
                <ul className="border-t">
                    {tasks.map((task, idx) => (
                        <li key={idx} className="flex items-center px-4 py-2">
                            <input type="checkbox" className="mr-2" />
                            <span>{task}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default TaskCategory;
